import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Footer from "./components/Footer/Footer";
import './App.css';
import Accueil from "./pages/Accueil";
import Experiences from "./pages/Experiences";
import Projets from "./pages/Projets";
import ProjetDetails from "./pages/ProjetDetails";
import MentionsLegales from "./pages/MentionsLegales";
import Admin from "./pages/Admin";
import { trackPageview } from "./services/api";

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin-bj');

  useEffect(() => {
    if (isAdmin) return;
    trackPageview(location.pathname, document.referrer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, isAdmin]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/projets" element={<Projets />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/projet/:id" element={<ProjetDetails />} />
        <Route path="/admin-bj/*" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;